import type { ReservationRequestStatus as BaseReservationRequestStatus } from "@lemmonhq/types";
export type ReservationRequestStatus = BaseReservationRequestStatus;

export interface TableAssignment {
  table_id: number;
  table_name?: string;
  status?: string;
}

export interface LinkedReservation {
  id: string;
  time: string;
  duration_mins: number;
  status: string;
  party_size: number;
  table_assignments?: TableAssignment[];
}

import type { ReservationRequest as BaseReservationRequest } from "@lemmonhq/types";
export type ReservationRequest = BaseReservationRequest;

export const STATUS_CONFIG: Record<
  string,
  { labelKey: string; bgClass: string; textClass: string; icon: string }
> = {
  pending: {
    labelKey: "reservations.request_status.pending_review",
    bgClass: "bg-amber-500/10",
    textClass: "text-amber-500",
    icon: "schedule",
  },
  ignored: {
    labelKey: "reservations.status.ignored",
    bgClass: "bg-base-300",
    textClass: "text-base-content/60",
    icon: "visibility_off",
  },
  confirmed: {
    labelKey: "reservations.status.confirmed",
    bgClass: "bg-emerald-500/10",
    textClass: "text-emerald-500",
    icon: "check_circle",
  },
  cancelled_by_host: {
    labelKey: "reservations.status.declined_by_host",
    bgClass: "bg-rose-500/10",
    textClass: "text-rose-500",
    icon: "cancel",
  },
  cancelled_by_user: {
    labelKey: "reservations.status.cancelled_by_user_label",
    bgClass: "bg-gray-500/10",
    textClass: "",
    icon: "cancel",
  },
  rejected: {
    labelKey: "reservations.status.rejected",
    bgClass: "bg-rose-500/10",
    textClass: "text-rose-500",
    icon: "cancel",
  },
  // Backward compatibility for old status values
  cancelled: {
    labelKey: "reservations.request_status.declined",
    bgClass: "bg-rose-500/10",
    textClass: "text-rose-500",
    icon: "cancel",
  },
  converted: {
    labelKey: "reservations.request_status.booked",
    bgClass: "bg-sky-500/10",
    textClass: "text-sky-500",
    icon: "event_available",
  },
};

export const STATUS_TABS: {
  value: ReservationRequestStatus | "reservations";
  labelKey: string;
  icon: string;
}[] = [
  {
    value: "reservations",
    labelKey: "reservations.status.confirmed",
    icon: "event_available",
  },
  {
    value: "pending",
    labelKey: "reservations.status.pending",
    icon: "schedule",
  },
  {
    value: "rejected",
    labelKey: "reservations.status.rejected",
    icon: "cancel",
  },
  {
    value: "cancelled_by_host",
    labelKey: "reservations.request_status.declined",
    icon: "cancel",
  },
];
